
import { Input, Button, Form, FormItem } from 'element-ui';
import { CustumerHelpers } from '@/helpers/CustumerHelpers';
import ContentLayout from '@/pages/content/components/ContentLayout.vue';
import Captcha from '../components/Captcha.vue';
import { CheckCircleIcon } from 'vue-feather-icons';
export default {
  layout: 'MainLayout',
  name: 'ShopPage',
  auth: false,

  data() {
    return {
      showCaptchaError: false,
      loading: false,
      success: false,
      captchaVerified: false,
      captchaToken: null,
      captchaErrorMessage: '',
      formFields: {
        firstname: '',
        lastname: '',
        email: '',
        subject: '',
        message: '',
      },
      rules: {
        firstname: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
        subject: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],

        email: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
          {
            type: 'email',
            message: this.$t('Please input correct email address'),
            trigger: 'blur',
          },
        ],
        message: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },

          {
            min: 6,
            message: this.$t('At least {0} characters', [3]),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    onCaptchaVerified(response) {
      this.captchaVerified = true;
      this.captchaToken = response;
      this.showCaptchaError = false;
      this.captchaErrorMessage = '';
    },
    onCaptchaExpired() {
      this.captchaVerified = false;
      this.captchaToken = null;
    },
    onCaptchaError() {
      this.captchaVerified = false;
      this.captchaToken = null;
      this.showCaptchaError = true;
      this.captchaErrorMessage = this.$t('Captcha verification failed. Please try again.');
    },
    sumbit() {
      if (!this.captchaVerified) {
        this.showCaptchaError = true;
        if (!this.captchaErrorMessage) {
          this.captchaErrorMessage = this.$t('Please complete the captcha');
        }
        return;
      }

      const custumerHelpers = new CustumerHelpers(this.$http, this.$auth);
      this.$refs['contactusForm'].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const data = {
            Firstname: this.formFields.firstname,
            Lastname: this.formFields.lastname,
            Email: this.formFields.email,
            Subject: this.formFields.subject,
            Message: this.formFields.message,
            RecaptchaToken: this.captchaToken,
          };

          try {
            await custumerHelpers.createTicketContact(data);
            this.formFields = {
              firstname: '',
              lastname: '',
              email: '',
              subject: '',
              message: '',

            };
            this.success = true;
            this.resetCaptchaState();
          } catch (error) {
            if (error && error.response && error.response.data) {
              const responseData = error.response.data;
              if (responseData.code === 'captcha_failed') {
                this.showCaptchaError = true;
                this.captchaErrorMessage = this.$t('Captcha verification failed. Please try again.');
                this.resetCaptchaState();
              }
              if (responseData.message && this.$notify && this.$notify.error) {
                this.$notify.error({
                  title: this.$t('Error'),
                  message: this.$t(responseData.message),
                });
              }
            } else {
              console.error(error);
            }
          } finally {
            this.loading = false;
            if (this.$refs.captcha && this.$refs.captcha.reset) {
              this.$refs.captcha.reset();
            }
          }
        } else {
          return false;
        }
      });
    },
    resetCaptchaState() {
      this.captchaVerified = false;
      this.captchaToken = null;
      this.showCaptchaError = false;
      this.captchaErrorMessage = '';
    },
  },
  computed: {
    breadcrumbLinks() {
      const links = [
        {
          link: '/',
          text: this.$t('Home'),
        },
        {
          text: this.$t('Contact-us'),
        },
      ];
      return links;
    },
  },

  mounted() {
    if (process.client) {
      window.scrollTo(0, 0);
    }
  },

  beforeDestroy() {
    // Ensure captcha is cleaned up when leaving the page
    if (this.$refs.captcha) {
      this.$refs.captcha.cleanupRecaptcha();
    }
  },

  // This ensures captcha is reloaded when the page is cached and revisited
  activated() {
    if (this.$refs.captcha) {
      this.$refs.captcha.reset();
    }
  },
  components: {
    Input,
    Button,
    Form,
    FormItem,
    ContentLayout,
    Captcha,
    CheckCircleIcon,
  },
};
